import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeExchangeRateCommand extends BaseCommand {
  CommandName = "ChangeExchangeRate";
  Command: { Value: number };
  constructor(sessionId: string, operationId: string, value: number) {
    super(sessionId, operationId);
    this.Command = { Value: value };
  }
}
